import { render } from "./EnemyVessels.vue?vue&type=template&id=609aabc0"
import script from "./EnemyVessels.vue?vue&type=script&lang=js"
export * from "./EnemyVessels.vue?vue&type=script&lang=js"
script.render = render

export default script